function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.2915 6.20714C12.4487 5.38509 11.3241 4.93726 10.1605 4.95566C8.03115 4.95566 6.22273 6.42489 5.57792 8.4033V8.40336C5.23602 9.44013 5.23602 10.5628 5.57792 11.5996L5.5779 11.5996H5.58089C6.22869 13.5749 8.03412 15.0442 10.1635 15.0442C11.2626 15.0442 12.2063 14.7567 12.9376 14.2488V14.2467C13.7984 13.6639 14.3862 12.7468 14.5691 11.71H10.1605V8.4954H17.8591C17.9551 9.05366 18 9.62419 18 10.1916C18 12.7307 17.1128 14.8773 15.5692 16.3312L15.5708 16.3325C14.2182 17.6085 12.3618 18.3478 10.1605 18.3478C7.07442 18.3478 4.25231 16.5687 2.86674 13.7498V13.7497C1.70913 11.3909 1.70913 8.61194 2.86675 6.25316L2.86674 6.25315C4.25231 3.43118 7.07442 1.65211 10.1605 1.65211C12.1878 1.62757 14.1462 2.40668 15.6217 3.8238L13.2915 6.20714Z",
  fill: "currentColor"
});

function SvgIconGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.4922820b.svg";
export { ForwardRef as ReactComponent };